import React from "react";
import "../../assets/styles/components/_login.scss";
import logo from "../../assets/images/brand/Tensolite-Isologotipo-blanco.png";
import useForm from "../../hooks/useForm";
import toast from "react-hot-toast";
import useCliente from "../../hooks/useCliente";

const Login = () => {
  const {
    values,
    handleInputChange,
    emailError,
    errorEmailInput,
  } = useForm({
    email: "",
    url: '',
  });

  const { forgetPassword } = useCliente();

  const location = window.location
  values.url = `${location.origin}/clientes/nuevo-password/`;

  const MostrarMensajeError = (event) => {
    toast.error("Email no encontrado");
    event.preventDefault();
  };

  const VerificarCampos = (event, values) => {
    event.preventDefault()
    !emailError
      ? forgetPassword(values)
      : MostrarMensajeError(event);
  };

  return (
    <>
      <form
        className="container login__card-form allBorderRadius"
        onSubmit={(event) => VerificarCampos(event, values)}
      >
        <div className="logo-login">
          <img src={logo} alt="Logo Tensolite" className="logo" />
        </div>
        <div className="flex-col">
          <p className="textFooterLogin">
            Ingrese su mail para recuperar su contraseña
          </p>
          <div className={`inputNoEye ${errorEmailInput ? "input-error" : ""}`}>
            <input
              type="text"
              id="email"
              name="email"
              className="inputLogin"
              placeholder="Email"
              value={values.email}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <input type="submit" className="button--submit" value="ENVIAR" />
      </form>
    </>
  );
};

export default Login;
